import duration from './duration';

export default duration;
